<template>
	<div>
		<div class="body-main">
			<div class="body-top">
				<div class="top-texts" @click="tuichubianji">
					退出编辑
				</div>
				<div class="top-right">
					<el-button type="primary" plain class="baoyu" @click="save">保存</el-button>
				</div>
			</div>
			<div class="body-body">
				<div class="body-left">
					<ul class="left-lists">
						<li v-for="(item,index) in leftlist" :key="index" @click="leftdian(index,item)">
							<img v-if="leftbiao==index" :src="item.type_icon" alt="">
							<img v-else :src="item.type_gray_icon" alt="">
							<span :class="leftbiao==index?'bai':'hui'">{{item.type_name}}</span>
						</li>
					</ul>
				</div>
				<div class="body-middle">
					<ul class="middlelist" >
						<li v-for="(item,index) in leftlist[leftbiao].lists" :key="index" @click="lefttian(item)">
							<img class="xiaotuicon" :src="item.icon" alt="">
							<span>{{item.name}}</span>
						</li>
					</ul>
				</div>
				<div class="body-center" :style="bodymain">
					<div class="topbumain" id="boxss">
						<img src="../../assets/img/title.png" alt="">
					</div>
					<div class="mainbodus">
						<ul id="boxs" class="ullistmain">
							<draggable element="ul" v-model="biglist" :options="{animation:250}" @input="handleListChange($event)">
								<li v-for="(item,index) in biglist" :key="index" :class="bigitem==index?'lanse':''" @click="middleclick(index,item,$event)">
									<div v-if="item.mark=='top'">
										<tophaves v-bind:author='item.content' v-bind:shujishu='shujiss'></tophaves>
									</div>
									<div v-if="item.mark=='searchbar'">
										<searchhaves v-bind:author='item' v-bind:shujishu='shujis'></searchhaves>
									</div>
									<div v-if="item.mark=='planting'">
										<div v-if="item.content.content.length==0">
											<plantingnones v-bind:author='item.content' v-bind:shujishu='shujip'></plantingnones>
										</div>
										<div v-else>
											<plantinghaves v-bind:author='item.content' v-bind:shujishu='shujip'></plantinghaves>
										</div>
									</div>
									<div v-if="item.mark=='textaction'">
										<div v-if="item.content.content.length==0">
											<textactionnones v-bind:author='item.content' v-bind:shujishu='shujit'></textactionnones>
										</div>
										<div v-else>
											<textactionhaves v-bind:author='item.content' v-bind:shujishu='shujit'></textactionhaves>
										</div>
									</div>
									<div v-if="item.mark=='picturegroup'">
										<div v-if="item.content.content.length==0">
											<picturegroupnones v-bind:author='item.content' v-bind:shujishu='shujig'></picturegroupnones>
										</div>
										<div v-else>
											<picturegrouphaves v-bind:author='item.content' v-bind:shujishu='shujig'></picturegrouphaves>
										</div>
									</div>
									<div v-if="item.mark=='stationnav'">
										<div v-if="item.content.content.length==0">
											<stationones v-bind:author='item.content.info' v-bind:shujishu='shuji'></stationones>
										</div>
										<div v-else>
											<stationhaves v-bind:author='item.content' v-bind:shujishu='shuji'></stationhaves>
										</div>
									</div>
									<div v-if="item.mark=='plantingtoo'">
										<div v-if="item.content.content.length==0">
											<plantingtoonones v-bind:author='item.content' v-bind:shujishu='shujilm'></plantingtoonones>
										</div>
										<div v-else>
											<plantingtoohaves v-bind:author='item.content' v-bind:shujishu='shujilm'></plantingtoohaves>
										</div>
									</div>
									<div v-if="item.mark=='blank'">
                                        <blankvues v-bind:author='item.content' v-bind:shujishu='shujibank'></blankvues>
									</div>
									<div v-if="item.mark=='textbox'" :style="{backgroundColor:item.content.info.h5backgroundColor,paddingLeft:item.content.info.paddingLeft+'px',paddingRight:item.content.info.paddingRight+
								'px',paddingTop:item.content.info.paddingTop+'px',paddingBottom:item.content.info.paddingBottom+'px'}">
										<div v-html="item.content.info.textinfo" class="maininfosptext">

										</div>
									</div>
									<div v-if="item.mark=='video'">
										<div v-if="item.content.content.length==0">
											<videonones v-bind:author='item.content' v-bind:shujishu='shujishi'></videonones>
										</div>
										<div v-else>
											<videohaves v-bind:author='item.content' v-bind:shujishu='shujishi'></videohaves>
										</div>
									</div>
									<div v-if="item.mark=='column'">
										<div v-if="item.content.content.length==0">
											<columnnones v-bind:author='item.content' v-bind:shujishu='shujicol'></columnnones>
										</div>
										<div v-else>
											<columnhaves v-bind:author='item.content' v-bind:shujishu='shujicol'></columnhaves>
										</div>
									</div>
									<div v-if="item.mark=='bigcolumn'">
										<div v-if="item.content.content.length==0">
											<bigcolumnnones v-bind:author='item.content' v-bind:shujishu='shujibig'></bigcolumnnones>
										</div>
										<div v-else>
											<bigcolumnhaves v-bind:author='item.content' v-bind:shujishu='shujibig'></bigcolumnhaves>
										</div>
									</div>
									<div v-if="item.mark=='livecourse'">
										<div>
											<livecoursehaves v-bind:author='item.content' v-bind:shujishu='shujiliv'></livecoursehaves>
										</div>
									</div>
									<div v-if="item.mark=='coursenav'">
										<div v-if="item.content.content.length==0">
											<coursenavnones v-bind:author='item.content' v-bind:shujishu='shujinav'></coursenavnones>
										</div>
										<div v-else>
											<coursenavhaves v-bind:author='item.content' v-bind:shujishu='shujinav' @senlaoshi='getbianle'></coursenavhaves>
										</div>
									</div>
									<div v-if="item.mark=='tearch'">
										<div v-if="item.content.content.length==0">
											<tearchnones v-bind:author='item.content' v-bind:shujishu='shujite'></tearchnones>
										</div>
										<div v-else>
											<tearchhaves v-bind:author='item.content' v-bind:shujishu='shujite'></tearchhaves>
										</div>
									</div>
									<div v-if="item.mark=='videoplayer'">
										<div v-if="item.content.info.demand_url==''">
											<videoplayernones v-bind:author='item.content' v-bind:shujishu='shuijiper'></videoplayernones>
										</div>
										<div v-else>
											<videoplayerhaves v-bind:author='item.content' v-bind:shujishu='shuijiper'></videoplayerhaves>
										</div>
									</div>
								</li>
							</draggable>
						</ul>
					</div>
				</div>
				<div class="adddels" v-if="showBox">
					<i @click="dels" class="el-icon-delete" :style="{left: 0, top: tranTop}"></i>
				</div>
				<div class="body-rights">
					<div v-if="leftmark.mark=='top'">
						<tops :key=bigitem @sendinfotop='gettopinfo' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem'></tops>
					</div>
					<div v-if="leftmark.mark=='searchbar'">
						<searchbars v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem' :key=bigitem
						 @sendsearchinfo='getsearchinfo'></searchbars>
					</div>
					<div v-if="leftmark.mark=='planting'">
						<plantings @sendplanting='getlunbo' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem'
						 :key=bigitem v-bind:typejumps='1'></plantings>
					</div>
					<div v-if="leftmark.mark=='textaction'">
						<textactions @sendtextinfo='gettextinfo' v-bind:typejumps='1' v-bind:author='biglist' v-bind:types='leftmark'
						 v-bind:itemindex='bigitem' :key=bigitem></textactions>
					</div>
					<div v-if="leftmark.mark=='picturegroup'">
						<picturegroups @sendpicturegroup='getpicturegroup' v-bind:author='biglist' v-bind:types='leftmark'
						 v-bind:itemindex='bigitem' :key="bigitem" v-bind:typejumps='1'></picturegroups>
					</div>
					<div v-if="leftmark.mark=='stationnav'">
						<stationnavs @sendstation='getstation' v-bind:typejumps='1' v-bind:author='biglist' v-bind:types='leftmark'
						 v-bind:itemindex='bigitem' :key=bigitem></stationnavs>
					</div>
					<div v-if="leftmark.mark=='blank'">
						<blanks v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem' :key=bigitem @sendbank='getbank'></blanks>
					</div>
					<div v-if="leftmark.mark=='textbox'">
						<textboxs @senbankinfo='getbankss' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem'
						 :key=bigitem></textboxs>
					</div>
					<div v-if="leftmark.mark=='plantingtoo'">
						<plantingtoomains @sentongping='gettongping' v-bind:typejumps='1' v-bind:author='biglist' v-bind:types='leftmark'
						 v-bind:itemindex='bigitem' :key=bigitem></plantingtoomains>
					</div>
					<div v-if="leftmark.mark=='video'">
						<videos @sendvideo='getvideo' v-bind:typejumps='1' v-bind:author='biglist' v-bind:types='leftmark'
						 v-bind:itemindex='bigitem' :key=bigitem></videos>
					</div>
					<div v-if="leftmark.mark=='column'">
						<columns @sendcolumn='getcolumn' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem' :key=bigitem></columns>
					</div>
					<div v-if="leftmark.mark=='bigcolumn'">
						<bigcolumns @sendbigcolumn='getbigcolumn' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem'
						 :key=bigitem></bigcolumns>
					</div>
					<div v-if="leftmark.mark=='livecourse'">
						<livecourses @sendlivecourse='getlivecourse' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem'
						 :key=bigitem></livecourses>
					</div>
					<div v-if="leftmark.mark=='coursenav'">
						<coursenavs v-bind:suijijianting='shujiother' v-bind:shiindex='xuandemain' @sendcoursenav='getcoursena'
						 v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem' :key=bigitem></coursenavs>
					</div>
					<div v-if="leftmark.mark=='tearch'">
						<tearchs @sendtearch='gettearch' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem' :key=bigitem></tearchs>
					</div>
					<div v-if="leftmark.mark=='videoplayer'">
						<videoplayers @sendvideopalyer='getpalyer' v-bind:author='biglist' v-bind:types='leftmark' v-bind:itemindex='bigitem'
						 :key=bigitem></videoplayers>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import draggable from 'vuedraggable'
	import "./home.css"
	export default {
		components: {
			draggable,
			tops: resolve => {
				require(["./newpart/top.vue"], resolve);
			},
			searchbars: resolve => {
				require(["./newpart/searchbar.vue"], resolve);
			},
			blanks: resolve => {
				require(["./newpart/blank.vue"], resolve);
			},
			textboxs: resolve => {
				require(["./newpart/textbox.vue"], resolve);
			},
			plantings: resolve => {
				require(["./newpart/planting.vue"], resolve);
			},
			textactions: resolve => {
				require(["./newpart/textaction.vue"], resolve);
			},
			picturegroups: resolve => {
				require(["./newpart/picturegroup.vue"], resolve);
			},
			stationnavs: resolve => {
				require(["./newpart/stationnav.vue"], resolve);
			},
			stationones: resolve => {
				require(["./nonecontent/stationone.vue"], resolve);
			},
			stationhaves: resolve => {
				require(["./haveconcent/stationhave.vue"], resolve);
			},
			plantingnones: resolve => {
				require(["./nonecontent/plantingnone.vue"], resolve);
			},
			plantinghaves: resolve => {
				require(["./haveconcent/plantinghave.vue"], resolve);
			},
			searchhaves: resolve => {
				require(["./haveconcent/searchhave.vue"], resolve);
			},
			textactionnones: resolve => {
				require(["./nonecontent/textactionnone.vue"], resolve);
			},
			textactionhaves: resolve => {
				require(["./haveconcent/textactionhave.vue"], resolve);
			},
			picturegroupnones: resolve => {
				require(["./nonecontent/picturegroupnone.vue"], resolve);
			},
			picturegrouphaves: resolve => {
				require(["./haveconcent/picturegrouphave.vue"], resolve);
			},
			plantingtoonones: resolve => {
				require(["./nonecontent/plantingtoonone.vue"], resolve);
			},
			plantingtoohaves: resolve => {
				require(["./haveconcent/plantingtoohave.vue"], resolve);
			},
			plantingtoomains: resolve => {
				require(["./newpart/plantingtoomain.vue"], resolve);
			},
			videos: resolve => {
				require(["./newpart/video.vue"], resolve);
			},
			videonones: resolve => {
				require(["./nonecontent/videonone.vue"], resolve);
			},
			videohaves: resolve => {
				require(["./haveconcent/videohave.vue"], resolve);
			},
			columns: resolve => {
				require(["./newpart/column.vue"], resolve);
			},
			columnnones: resolve => {
				require(["./nonecontent/columnnone.vue"], resolve);
			},
			bigcolumns: resolve => {
				require(["./newpart/bigcolumn.vue"], resolve);
			},
			bigcolumnnones: resolve => {
				require(["./nonecontent/bigcolumnnone.vue"], resolve);
			},
			bigcolumnhaves: resolve => {
				require(["./haveconcent/bigcolumnhave.vue"], resolve);
			},
			livecourses: resolve => {
				require(["./newpart/livecourse.vue"], resolve);
			},
			livecoursenones: resolve => {
				require(["./nonecontent/livecoursenone.vue"], resolve);
			},
			livecoursehaves: resolve => {
				require(["./haveconcent/livecoursehave.vue"], resolve);
			},
			coursenavs: resolve => {
				require(["./newpart/coursenav.vue"], resolve);
			},
			coursenavnones: resolve => {
				require(["./nonecontent/coursenavnone.vue"], resolve);
			},
			coursenavhaves: resolve => {
				require(["./haveconcent/coursenavhave.vue"], resolve);
			},
			tearchs: resolve => {
				require(["./newpart/tearch.vue"], resolve);
			},
			videoplayers: resolve => {
				require(["./newpart/videoplayer.vue"], resolve);
			},
			tearchnones: resolve => {
				require(["./nonecontent/tearchnone.vue"], resolve);
			},
			tearchhaves: resolve => {
				require(["./haveconcent/tearchhave.vue"], resolve);
			},
			columnhaves: resolve => {
				require(["./haveconcent/columnhave.vue"], resolve);
			},
			videoplayernones: resolve => {
				require(["./nonecontent/videoplayernone.vue"], resolve);
			},
			videoplayerhaves: resolve => {
				require(["./haveconcent/videoplayerhave.vue"], resolve);
			},
			tophaves: resolve => {
				require(["./haveconcent/tophave.vue"], resolve);
			},
			blankvues: resolve => {
				require(["./haveconcent/blankvue.vue"], resolve);
			},
		},
		data() {
			return {
				url: this.$store.state.p_url,
				imgUrl: this.$store.state.img_url,
				showBox: false,
				bodymain: {
					backgroundColor: '',
					backgroundImage: ''

				},
				topbgmain: {
					backgroundColor: '',
				},
				toppart: {},
				leftlist: [{
					"list": []
				}, {
					"list": []
				}],
				biglist: [],
				bigitem: 999,
				leftbiao: 0,
				leftmark: {
					mark: ''
				},
				mainimg: 'https://oss.qikeya.cn/Uploads/202009/c8b417abda09b4cb0cc1a95c236ef91c.jpg',
				imgarr: [{
					img: 'https://oss.qikeya.cn/Uploads/202009/c8b417abda09b4cb0cc1a95c236ef91c.jpg'
				}, {
					img: 'https://oss.qikeya.cn/Uploads/202009/845e7c40189908fd93ac5959722bf006.jpg'
				}],
				shuji: 1,
				shujip: 1,
				shujis: 1,
				shujit: 1,
				shujig: 1,
				shujilm: 1,
				shujishi: 1,
				shujicol: 1,
				shujibig: 1,
				shujinav: 1,
				shujite: 1,
				pageid: '',
				livearr: [],
				shujiliv: 1,
				need_sync: '',
				bigitemid: "",
				tranLeft: 0, // 向左偏移
				tranTop: 0, // 向右偏移,
				shujiother: 1,
				xuandemain: 0,
				shuijiper: 1,
				shujiss: 1,
				shujibank:1
			}
		},
		methods: {
			tuichubianji() {
				this.opendel()
			},
			opendel() {
				this.$confirm('是否退出编辑', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/',
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			leftdian(index, item) {
				this.leftbiao = index
			},
			middleclick(index, item, e) {
				this.bigitem = index
				this.leftmark = item
				this.bigitemid = item.id
				let rect = e.target.getBoundingClientRect()
				this.tranLeft = (1140) + 'px'
				this.tranTop = (rect.y - 120) + 'px'
				this.showBox = true
			},
			lefttian(item) {
				let obj = {
					mark: '',
					content: {
						info: {},
						content: [],
					},
				}
				if (item.mark == 'top') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)',
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								bgtype: 1,
								h5bbackgroundColor: 'rgba(255,255,255,1)',
								bbackgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								show: 3,
								textposition: 2,
								icontype: 2,
								text: '首页',
								bgimg: '',
								bbgimg: '',
								titlefont:1,
								titleweight:600,
								h5titlebackgroundColor:'rgba(23,16,16,1)',
								titlebackgroundColor:{
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
							},
						},
					}
					let mainindex = -1
					if (this.biglist.length != 0) {
						this.biglist.forEach((items, indexs) => {
							if (items.mark == 'top'||items.mark == 'plantingtoo' ) {
								mainindex = items
							}
						})
						if (mainindex == -1) {
							 this.biglist.splice(0, 0, obj)
							 this.bigitem = 0
							 this.leftmark = item
						} else {
							if(mainindex.mark=='top'){
                               this.$message({
								type: 'info',
								message: '您已经添加过该组件'
							 });
							}else if(mainindex.mark=='plantingtoo'){
                               this.$message({
								 type: 'info',
								 message: '通屏轮播图和顶部组件只能添加一种'
							  });
							}
							this.bigitem = 0
							this.leftmark = this.biglist[this.bigitem]
						}
					} else {
						this.biglist.push(obj)
						this.leftmark = this.biglist[this.bigitem]
					    this.bigitem = this.biglist.length - 1
					}
					this.gundong1()
				} else if (item.mark == 'searchbar') {
					obj = {
						mark: item.mark,
						content: {
							content: [],
							info: {
								show: 1, //搜索样式
								h5bordercolor: 'rgba(255,255,255,1)',//边框颜色
								bordercolor: { //边框颜色
									r:255,
									g:255,
									b:255,
									a:1,
								},
								textposition: 1,//搜索框内容位置 1居中 2靠左
								text: '搜索课程名称',
								iconshow: 1,// 搜索图标 1展示 2不展示
								icontype: 1, //搜索图标样式
								backgroundColor:{ //背景色
									r:255,
									g:255,
									b:255,
									a:1,
								},
								h5backgroundColor:'rgba(255,255,255,1)',//背景色
								paddingLeft: 20,
								paddingRight: 20,
								paddingTop: 8,
								paddingBottom: 8,
								type:1,
								bordershow:1,
							},
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
				    this.leftmark = item
					this.gundong()
				} else if (item.mark == 'blank') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								height: 20,
								bgimg:'',
								h5backgroundColor: 'rgba(255,255,255,1)',
								type: 1,
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								}
							},
							content: [],
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
				    this.leftmark = item
					this.gundong()
				} else if (item.mark == 'textbox') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								paddingLeft: 24,
								paddingRight: 24,
								paddingTop: 30,
								paddingBottom: 30,
								textinfo: '',
								h5backgroundColor: 'rgba(255,255,255,1)',
							},
							content: [],
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'planting') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)',
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								show: 1,
								indicatorposition: 1,
								width: 347,
								height: 208,
								paddingLeft: 12,
								paddingRight: 12,
								paddingTop: 15,
								paddingBottom: 15,
								borderRadius: 4,
								imgsize: 1,
								bgimg: '',
							},
							content: [],
						},
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					this.leftmark = item
					this.gundong()
				} else if (item.mark == 'textaction') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)',
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								borderRadius: 4,
								height: 150,
								paddingLeft: 12,
								paddingRight: 12,
								paddingTop: 15,
								paddingBottom: 15,
								bgimg: '',
							},
							content: []
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'picturegroup') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1, // 模块背景 1背景色 2背景图
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: { //背景色
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								show: 2, // 展示个数  1两个 2三个 3四个
								showtype: 1, //三个展示样式
								borderRadius: 4, // 圆角大小
								height: 208, //图片高
								paddingTop: 15,
								paddingBottom: 15,
								paddingLeft: 12,
								paddingRight: 12,
								bgimg: '', //背景图
								titlefont:2,
								titleweight:400,
								h5titlebackgroundColor:'rgba(23,16,16,1)',
								titlebackgroundColor:{
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
							},
							content: [],
						},
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'stationnav') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								h5color: '#333',
								color: {
									r: '51',
									g: '51',
									b: '51',
									a: '1',
								},
								show: 1,
								showtype: 1,
								showtypenum: 1,
								iconshow: 1,
								imgsize: 1,
								fontsixze: 1,
								isradius: 1,
								borderRadius: 5,
								paddingTop: 15,
								paddingLeft: 12,
								paddingRight: 12,
								paddingBottom: 15,
								bgimg: '',
						        opnecard: 1,
							},
							content: [],
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					this.shuji = Math.random()
					this.gundong()
				} else if (item.mark == 'plantingtoo') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								show: 1,
								h5bordercolor: 'rgba(255,255,255,1)', //背景色
								bordercolor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								textposition: 1,
								text: '搜索课程名称',
								iconshow: 1,
								icontype: 1,
								paddingLeft: 20,
								paddingRight: 20,
								paddingTop: 0,
								paddingBottom: 0,
								imgsize: 1,
								indicatorposition: 1,
								toptext: '首页',
						        bordershow:1,
								titlefont:1,
								titleweight:600,
								h5titlebackgroundColor:'rgba(23,16,16,1)',
								titlebackgroundColor:{
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
							},
							content: [],
							contenttoo: [],
						},
					}
					let mainindex = -1
					if (this.biglist.length != 0) {
						this.biglist.forEach((items, indexs) => {
							if (items.mark == 'top' || items.mark == 'plantingtoo') {
								mainindex = items
							}
						})
						if (mainindex == -1) {
							this.biglist.splice(0, 0, obj)
							this.bigitem = 0
					        this.leftmark = item
						} else {
							if(mainindex.mark=='plantingtoo'){
                               this.$message({
								type: 'info',
								message: '您已经添加过该组件'
							 });
							}else if(mainindex.mark=='top'){
                               this.$message({
								 type: 'info',
								 message: '通屏轮播图和顶部组件只能添加一种'
							  });
							}
							this.bigitem = 0
							this.leftmark = this.biglist[this.bigitem]
						}
					} else {
						this.biglist.push(obj)
						this.bigitem = this.biglist.length - 1
						this.leftmark = this.biglist[this.bigitem]
					}
					this.gundong1()
				} else if (item.mark == 'video') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								type: 1,
								show: 1,
								fontsixze: 1,
								h5color: 'rgba(23,16,16,1)',
								color: {
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								pricesize: 1,
								fuconcent: 1,
								h5concentcolor: 'rgba(142,138,138,1)',
								concentcolor: {
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},
								h5pricecolor: 'rgba(224,60,60,1)',
								pricecolor: {
									r: 224,
									g: 60,
									b: 60,
									a: 1,
								},
								pointstyle: 2,
								modelstyle: 1,
								checkout: 1,
								paddingTop: 15,
								paddingBottom: 15,
								title: "视频商品",
								desc: '模块描述',
								sort: 2,
								hande: 2,
								coursetype: 'video,live,bigcolumn,column,offline',
								bgimg: '',
								subcategory: '',
								category: '',
								bignames: [],
								showtype:2, //课展示数量 1(2个) 2（个） 3 （6个）
						        showtypes: 4,//课展示数量 2 4 6
								opnecard:1,
								titlefont:2,
								titleposition:1,
								titleweight:400,
								h5titlebackgroundColor:'rgba(23,16,16,1)',
								titlebackgroundColor:{
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								descsize:1,
								h5descbackgroundColor:'rgba(142,138,138,1)',
								descbackgroundColor:{
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},


							},
							content: [],
						},
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'column') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								show: 1,
								fontsixze: 1,
								h5color: 'rgba(23,16,16,1)',
								color: {
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								fuconcent: 1,
								h5concentcolor: 'rgba(142,138,138,1)',
								concentcolor: {
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},
								pointstyle: 2,
								updatatype: 2,
								updateshow: 2,
								paddingTop: 15,
								paddingBottom: 15,
								title: '专栏课',
								desc: '模块描述',
								modelstyle: 1,
								checkout: 1,
								sort: 2,
								bgimg: '',
								pricesize:1,
								h5pricecolor: 'rgba(224,60,60,1)',
								pricecolor: {
									r: 224,
									g: 60,
									b: 60,
									a: 1,
								},
								showtype:2, //课展示数量 1(2个) 2（个） 3 （6个）
						        showtypes: 4,//课展示数量 2 4 6
								opnecard:1,
								titlefont:2,
								titleposition:1,
								titleweight:400,
								h5titlebackgroundColor:'rgba(23,16,16,1)',
								titlebackgroundColor:{
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								descsize:1,
								h5descbackgroundColor:'rgba(142,138,138,1)',
								descbackgroundColor:{
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},
							},
							content: [],
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'bigcolumn') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								show: 1,
								fontsixze: 1,
								h5color: 'rgba(23,16,16,1)',
								color: {
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								fuconcent: 1,
								h5concentcolor: 'rgba(142,138,138,1)',
								concentcolor: {
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},
								pointstyle: 2,
								updatatype: 2,
								updateshow: 2,
								paddingTop: 15,
								paddingBottom: 15,
								title: '大专栏',
								desc: '模块描述',
								modelstyle: 1,
								checkout: 1,
								sort: 2,
								bgimg: '',
								pricesize:1,
								h5pricecolor: 'rgba(224,60,60,1)',
								pricecolor: {
									r: 224,
									g: 60,
									b: 60,
									a: 1,
								},
								showtype:2, //课展示数量 1(2个) 2（个） 3 （6个）
						        showtypes: 4,//课展示数量 2 4 6
								opnecard:1,
								titlefont:2,
								titleposition:1,
								titleweight:400,
								h5titlebackgroundColor:'rgba(23,16,16,1)',
								titlebackgroundColor:{
											r: 23,
											g: 16,
											b: 16,
											a: 1,
										},
								descsize:1,
								h5descbackgroundColor:'rgba(142,138,138,1)',
								descbackgroundColor:{
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},
							},
							content: [],
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'livecourse') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								show: 1,
								fontsixze: 1,
								h5color: 'rgba(23,16,16,1)',
								color: {
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								pricesize: 1,
								h5pricecolor: 'rgba(224,60,60,1)',
								pricecolor: {
									r: 224,
									g: 60,
									b: 60,
									a: 1,
								},
								tearchshow: 1,
								h5tearchcolor: 'rgba(23,16,16,1)',
								tearchcolor: {
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								startime: 1,
								type: 1,
								livestatus: 1,
								pointstyle: 2,
								checkout: 1,
								paddingTop: 15,
								paddingBottom: 15,
								title: '直播课程',
								desc: '模块描述',
								showtype: 1,
								showtypes: 2,
								livehide: 1,
								sort: 2,
								coursetype: '1,2,3',
								bgimg: '',
								opnecard:1,
								modelstyle:1,
								titlefont:2, //标题大小 1.14px 2.16px 3.18px
								titleposition:1, //标题位置 1.左 2.居中
								titleweight:400,//标题加粗 400 不加粗  600加粗
								h5titlebackgroundColor:'rgba(23,16,16,1)',// 标题颜色：
								titlebackgroundColor:{  // 标题颜色：
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								descsize:1,//描述个大小 1.12px 2.14px 3.16px
								h5descbackgroundColor:'rgba(142,138,138,1)',//描述颜色
								descbackgroundColor:{ //描述颜色
									r: 142,
									g: 138,
									b: 138,
									a: 1,
						        },
							},
							content: this.livearr,
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'coursenav') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								show: 1,
								showtype: 1,
								fontsixze: 1,
								h5navcolor: 'rgba(' + 238 + ',' + 146 + ',' + 40 + ',' + 1 + ')',
								navcolor: {
									r: 238,
									g: 146,
									b: 40,
									a: 1,
								},
								fuconcent: 1,
								checkout: 1,
								pointstyle: 2,
								paddingTop: 15,
								paddingBottom: 15,
								navopen: 1,
								h5color: 'rgba(23,16,16,1)',
								color: {
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								h5pricecolor: 'rgba(224,60,60,1)',
								pricecolor: {
									r: 224,
									g: 60,
									b: 60,
									a: 1,
								},
								h5concentcolor: 'rgba(142,138,138,1)',
								concentcolor: {
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},
								bgimg: '',
								xuindex: 0,
								pricesize:1,
						        opnecard:1,
							},
							content: [],
						}
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'tearch') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								h5color: 'rgba(23,16,16,1)',
								color: {
									r: 23,
									g: 16,
									b: 16,
									a: 1
								},
								h5titlecolor: 'rgba(23,16,16,1)',
								titlecolor: {
									r: 23,
									g: 16,
									b: 16,
									a: 1
								},
								show: 1,
								fontsixze: 1,
								titlestyle: 1,
								paddingTop: 15,
								paddingBottom: 15,
								title: '讲师中心',
								desc: '模块描述',
								sort: 2,
								bgimg: '',
								checkout: 2,
								opnecard:1,
								modelstyle:1,
								titlefont:2, //标题大小 1.14px 2.16px 3.18px
								titleposition:1, //标题位置 1.左 2.居中
								titleweight:400,//标题加粗 400 不加粗  600加粗
								h5titlebackgroundColor:'rgba(23,16,16,1)',// 标题颜色：
								titlebackgroundColor:{  // 标题颜色：
									r: 23,
									g: 16,
									b: 16,
									a: 1,
								},
								descsize:1,//描述个大小 1.12px 2.14px 3.16px
								h5descbackgroundColor:'rgba(142,138,138,1)',//描述颜色
								descbackgroundColor:{ //描述颜色
									r: 142,
									g: 138,
									b: 138,
									a: 1,
								},
							},
							content: [],
						},
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				} else if (item.mark == 'videoplayer') {
					obj = {
						mark: item.mark,
						content: {
							info: {
								type: 1,
								h5backgroundColor: 'rgba(255,255,255,1)', //背景色
								backgroundColor: {
									r: 255,
									g: 255,
									b: 255,
									a: 1,
								},
								paddingTop: 15,
								paddingBottom: 15,
								progress: 1,
								videobili: 100,
								imgsize: 1,
								autoplay: 1,
								bgimg: '',
								demand_url: '',
								percent: 0, //上传进度,
								havevideo: 3,
								filename: '',
								coverimg: "",
							},
							content: [],
						},
					}
					this.biglist.push(obj)
					this.bigitem = this.biglist.length - 1
					 this.leftmark = item
					 this.gundong()
				}
			},
			gettopinfo(res) {
				this.bodymain.backgroundColor = "rgba(" + res.bbackgroundColor.r + ',' + res.bbackgroundColor.g + ',' + res.bbackgroundColor
					.b + ',' + res.bbackgroundColor.a + ')'
				this.bodymain.backgroundImage = 'url(' + this.imgUrl + res.bbgimg + ')'
				this.biglist[this.bigitem].content.info = res
				this.shujiss = Math.random()
			},
			getsearchinfo(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujis = Math.random()
			},
			getbank(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.shujibank= Math.random()
			},
			getbankss(res) {
				this.biglist[this.bigitem].content.info = res.info
			},
			getlunbo(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujip = Math.random()
			},
			gettextinfo(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujit = Math.random()
			},
			getpicturegroup(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content =res.content
				this.shujig = Math.random()
			},
			getstation(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shuji = Math.random()
			},
			gettongping(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.biglist[this.bigitem].content.contenttoo = res.contenttoo
				this.shujilm = Math.random()
			},
			getvideo(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujishi = Math.random()
			},
			getcolumn(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujicol = Math.random()
			},
			getbigcolumn(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujibig = Math.random()
			},
			getcoursena(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujinav = Math.random()
			},
			gettearch(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujite = Math.random()
			},
			getlivecourse(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.biglist[this.bigitem].content.content = res.content
				this.shujiliv = Math.random()
			},
			getpalyer(res) {
				this.biglist[this.bigitem].content.info = res.info
				this.shuijiper = Math.random()
			},
			getbianle(res) {
				this.xuandemain = res
				this.shujiother = Math.random()
			},
			handleListChange(event) {
				let indexmain = ''
				event.forEach((item, index) => {
					if (item.id == this.bigitemid) {
						indexmain = index
					}
				})
				this.bigitem = indexmain
				let yidongindex = -1
				let objs = ''
				event.forEach((item, index) => {
					if (item.mark == 'plantingtoo' || item.mark == 'top') {
						yidongindex = index
						objs = item
					}
				})
				let kongarrs = []
				if (yidongindex != -1) {
					event.forEach((item, index) => {
						if (index != yidongindex) {
							kongarrs.push(item)
						}
					})
					kongarrs.splice(0, 0, objs)
					this.biglist=kongarrs
					this.shujig=Math.random()
					let kongingdex = -1
					this.biglist.forEach((item, index) => {
						if (item.id == this.bigitemid) {
							kongingdex = index
						}
					})
					if (kongingdex != -1) {
						this.bigitem = kongingdex
						this.leftmark = this.biglist[kongingdex]

					}
				}
			},
			save() {
				let that = this
				let ishave = -1
				let group = []
				let havecontent=[]
				this.biglist.forEach((item, index) => {
					if (item.mark == 'top' || item.mark == 'plantingtoo') {
						ishave = index
					}
					if (item.mark == 'picturegroup') {
						group.push(item)
					}
					if (item.mark == 'coursenav') {
						havecontent.push(item)
					}

				})
				if (ishave == -1) {
					this.$message({
						type: 'info',
						message: '请添加顶部或者通屏轮播图组件'
					});
					return
				}
				if(this.biglist[ishave].mark=='plantingtoo'){
					if(this.biglist[ishave].content.content.length==0){
						 this.$message({
								type: 'info',
								message: '请添加通屏轮播图图片'
						 });
						  return
					}
				}
                let bigarr=[]
				if (group.length != 0) {
					  group.forEach((itemg,indexg)=>{
						  if(itemg.content.content.length == 0){
                               bigarr.push(itemg)
						  }
						  itemg.content.content.forEach((itemts,indexts)=>{
                                if(itemts.img==''||itemts.img==undefined){
									bigarr.push(itemts)
								}
						  })
					  })
				}
				if(bigarr.length!=0){
					this.$message({
						type: 'info',
						message: '请添加图片'
					});
						return
				}
				let kongamian=[]
				let kongamians=[]
				if(havecontent.length!=0){
					havecontent.forEach((itemsts,indexsts)=>{
                         if(itemsts.content.content.length==0){
							 kongamian.push(itemsts)
						 }
						 if(itemsts.content.content.length!=0){
							 itemsts.content.content.forEach((itemstsc,indexstsc)=>{
								 if(itemstsc.lists.length==0){
									 kongamian.push(itemstsc)
								 }
								 if(itemstsc.lists.length!=0){
									 if(itemstsc.lists.length<Number(itemsts.content.info.showtype)+3){
                                        kongamians.push(itemstsc)
									 }
								 }
							 })
						 }

					})
				}
				if(kongamian.length!=0){
					this.$message({
						type: 'info',
						message: '分类导航组件内部分导航暂无课程，请添加后再试！'
					});
					return
				}
				if(kongamians.length!=0){
					this.$message({
						type: 'info',
						message: '分类导航组件内部分导航课程数量不足，请添加后再试！'
					});
					return
				}
				this.biglist.forEach((item, index) => {
					this.biglist[index].sort = index + 1
				})
				let maininfos = {
					bg_type: 1,
					bgimg: '',
					bgcolor: 'rgba(255,255,255,1)'
				}
				this.biglist.forEach((item, index) => {
					if (item.mark == 'top') {
						if (item.content.info.bgtype == 1) {
							maininfos.bgcolor = 'rgba('+item.content.info.bbackgroundColor.r+','+item.content.info.bbackgroundColor.g+','+item.content.info.bbackgroundColor.b+','+item.content.info.bbackgroundColor.a+')'
							maininfos.bgimg = ''
						} else {
							maininfos.bgcolor = ''
							maininfos.bgimg = item.content.info.bbgimg
						}
						maininfos.bg_type = item.content.info.bgtype
					}
				})
				let data = {
					lists: this.biglist,
					micro_page_id: this.pageid,
					name: '',
					bg_type: maininfos.bg_type,
					bgimg: maininfos.bgimg,
					bgcolor: maininfos.bgcolor
				}
				that.$axios.post(that.url + "service/shopDecoration/savePage", data).then(res => {
					if (Number(res.data.code) == 200) {
						this.open(data)
					} else {
						if (Number(res.data.code) == 30001) {
							$('.shadedianshow').fadeIn();
						} else {
							this.$message({
								message: res.data.msg,
								type: 'info'
							});
						}
					}
				})
			},
			open(data) {
				let that = this
				if (this.need_sync == 1) {
					let msg = ''
					if (this.$route.query.type == 1) {
						msg = '保存成功，是否同步店铺装修到移动端店铺？'
					} else {
						msg = '保存成功，是否同步店铺装修到APP端店铺？'
					}
					this.$confirm(msg, '提示', {
						confirmButtonText: '同步',
						cancelButtonText: '不同步',
						type: 'warning'
					}).then(() => {
						this.tongbus(data)
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消同步'
						});
					});
				} else {
					this.$alert('保存成功', {
						confirmButtonText: '确定',
						callback: action => {}
					});
				}
				this.pageList()
			},
			tongbus(data) {
				let that = this
				let datas = {
					micro_page_id: data.micro_page_id
				}
				that.$axios.post(that.url + "service/shopDecoration/syncPage", datas).then(res => {
					if (Number(res.data.code) == 200) {
						this.$message({
							type: 'info',
							message: '同步成功'
						});
					}
					this.$message({
						type: 'info',
						message: res.data.msg
					});
				})
			},
			pageList() {
				let that = this
				let data = ''
				if (this.$route.query.type == 1) {
					data = {
						type: 4
					}
				} else {
					data = {
						type: ''
					}
				}
				that.$axios.post(that.url + "service/ShopDecoration/pageList", data).then(res => {
					if (res.data.code == 200 || res.data.code == '200') {
						this.pageInfo(res.data.data[0].id)
						that.pageid = res.data.data[0].id
						this.bigitem=''
						this.leftmark=''
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			pageInfo(index) {
				let that = this
				that.$axios.post(that.url + "service/shopDecoration/pageInfo", {
					id: index
				}).then(res => {
					if (Number(res.data.code) == 200) {
						this.biglist = res.data.data.lists
						this.need_sync = Number(res.data.data.need_sync)
						this.bodymain.backgroundColor=res.data.data.bgcolor
						this.bodymain.backgroundImage ='url(' + this.imgUrl + res.data.data.bgimg + ')'
						that.loading = false
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			moduleList() {
				let that = this
				let data = ''
				if (this.$route.query.type == 1) {
					data = {
						platform: 'app'
					}
				} else {
					data = {
						platform: ''
					}
				}
				that.$axios.post(that.url + "service/ShopDecoration/moduleList", data).then(res => {
					if (res.data.code == 200 || res.data.code == '200') {
						that.leftlist = res.data.data
					}
				}).catch(function(err) {
					console.log(err)
				})
			},
			dels() {
				this.delopenmain()
			},
			delopenmain() {
				this.$confirm('确定要删除该组件吗', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.shanchumain()

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			shanchumain() {
				this.biglist.splice(this.bigitem, 1)
				this.showBox = false
				this.bigitem=''
				this.leftmark=''
			},
			//service/shopDecoration/liveList
			liveList() {
				let that = this
				let data = {
					kind: '1,2,3',
					show: 1
				}
				that.$axios.post(that.url + "service/shopDecoration/liveList", data).then(res => {
					if (Number(res.data.code) == 200) {
						this.livearr = res.data.data
					}
				})
			},
			gundong(){
				let ele = document.getElementById('boxs');
				ele.scrollTop = ele.scrollHeight;
			},
			gundong1(){
               let ele = document.getElementById('boxss');
				ele.scrollTop = ele.scrollHeight;
			},
		},
		mounted() {
			this.moduleList()
			this.pageList()
			this.liveList()
		}
	}
</script>
<style scoped>
	.body-rights {
		width: 363px;
		height: 95vh;
		float: right;
		box-shadow: 0px 6px 10px 0px rgba(230, 230, 230, 0.42);
		background-color: #fff;
		overflow: auto;
		padding-bottom: 30px;
	}

	.topbumain {
		width: 100%;
		height: 20px;
		position: absolute;
		top: 0;
	}

	.topmain {
		width: 100%;
		height: 44px;
		display: flex;
		position: relative;
	}

	.mainbodus {
		margin-top: 20px;
	}

	.main-right {
		position: absolute;
		right: 20px;
		top: 10px;
		font-size: 20px;
	}

	.juzhong {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-left: 15px;
	}

	.juzuos {
		display: flex;
		align-items: center;
		padding-left: 15px;
	}

	.searchbars {
		width: 100%;
		min-height: 28px;
	}

	.searchmain {
		width: 100%;
		height: 28px;
		background-color: #F5F5F5;
		margin: 0 auto;
		color: #989898;
		border-radius: 14px;
		border-width: 1px;
		border-style: solid;
	}

	.borderserach {
		border-radius: 10px;
	}

	.searchjuzhong {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 26px;
	}

	.juzuosearch {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 26px;
	}

	.mainsearchyang img {
		width: 16px;
		height: 16px;
		display: block;
		margin-right: 5px;
	}

	.mainsearchyang {
		padding: 0 10px;
	}

	.mainbodus ul li {
		cursor: pointer;
	}
	.maininfosptext {
		display: flex;
		flex-direction: column;
		overflow-wrap: break-word;
		max-width: 340px;
		overflow: auto;
	}
	.maininfosptext>>>img{
		max-width: 340px;
		display: block;
	}

	.mainlunbo {
		width: 100%;
		height: 100%;
	}

	.tupianda {
		display: block;
	}

	.maintext {
		width: 100%;
	}

	.textimg {
		width: 100%;
		display: block;
	}

	>>>.el-carousel__container {
		height: 100% !important;
	}

	.maindisplau {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.longone {
		width: 169px;
	}

	.longone img {
		display: block;
		width: 169px;
	}

	.longones {
		display: flex;
		flex-direction: column;
	}

	.mainfours {
		width: 100%;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.mainfours img {
		display: block;
		width: 110px;
	}

	.mainonehight {
		width: 100%;
	}

	.dispayminss {
		display: flex;
		align-items: center;
		justify-content: space-around;
		align-items: center;
	}

	.xiaotuicon {
		width: 32px;
		height: 24px;
		display: block;
	}

	.body-center {
		background-repeat: no-repeat;
		background-size: 100% 100%
	}
</style>



// WEBPACK FOOTER //
// src/components/zujian/home.vue